const LotesReservadosProdutoConsultaController = ControllerBase.extend({
    name: "LotesReservadosProdutoConsultaController",
    framework: "knockout",

    dataBreadcrumb: new DataBreadcrumb({
        columns: [
            { title: 'Produto', prop: 'CodigoProduto' },
            { title: 'Descrição', prop: 'DescricaoProduto' }
        ],
        getData: function () {
            var modelAux = this.produto.toJSON();

            if (modelAux.IdentificadorOrcamento) {
                modelAux.CodigoProduto = modelAux.CodigoProdutoExibicao;
            }

            return modelAux;
        },
    }),

    ajax: function() {

        this.filtros = {
            CodigoProduto: this.produto.get("IdentificadorOrcamento") ? this.produto.get("CodigoProduto") : this.produto.get("Codigo"), // FNX-998, FNX-999, FNX-1001
            Filial: null,
            NumeroPagina: 1,
            TamanhoPagina: 10
        };

        return {
            url: "/Produto/_LotesReservadosProdutoConsulta",
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({
                filtros: this.filtros
            })
        };
    },
    antesBinding: function() {

        var referenciaProduto = this.produto.get("ReferenciaProduto")
            ? this.produto.get("ReferenciaProduto")
            : this.produto.get("Referencia")
            ? this.produto.get("Referencia")
            : this.produto.get("Codigo");

        this.appendToModel({ name: "Filial", value: null });
        this.appendToModel({ name: "DescricaoProduto", value: this.produto.get("DescricaoProduto") });
        this.appendToModel({ name: "referenciaProduto", value: referenciaProduto });
    },

    aposBinding: function() {
        if (this.data) {
            this.atualizarPaginador(this.data.Lotes);
        }
        this.model.Filial.subscribe($.proxy(this.filialAlterada, this));
        $("input").on('focus', function () { $(this).select(); });
        $("textarea").on('focus', function () { $(this).select(); });
    },

    filialAlterada: function() {
        this.filtros.Filial = this.model.Filial();
        this.pesquisar();
    },
    pesquisar: function(pagina) {
        var self = this;
        this.filtros.NumeroPagina = pagina || 1;
        global.ajax({
            url: "/Produto/ListarLotesReservados",
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({
                filtros: this.filtros
            }),
            success: function(data) {
                if (!data || data.HasErrors) {
                    self.model.Lotes().Entities.removeAll();
                    self.model.Totais().QuantidadeLotes(undefined);
                    self.model.Totais().QuantidadeSaidaLote(undefined);
                    self.model.Totais().QuantidadeCaixasSaidaLote(undefined);
                    self.model.Totais().QuantidadeReservaLote(undefined);
                    self.model.Totais().QuantidadeCaixasReservaLote(undefined);

                    self.model.QuantidadeLotesPagina(undefined);
                    self.model.QuantidadeSaidaLotePagina(undefined);
                    self.model.QuantidadeCaixasSaidaLotePagina(undefined);
                    self.model.QuantidadeReservaLotePagina(undefined);
                    self.model.QuantidadeCaixasReservaLotePagina(undefined);

                    self.atualizarPaginador(data.Lotes);

                    return;
                }
                var m = ko.mapping.fromJS(data.Lotes.Entities);
                self.model.Lotes().Entities(m());
                self.atualizarPaginador(data.Lotes);

                var t = ko.mapping.fromJS(data.Totais);

                self.model.Totais(t);

                self.model.QuantidadeLotesPagina(data.QuantidadeLotesPagina);
                self.model.QuantidadeSaidaLotePagina(data.QuantidadeSaidaLotePagina);
                self.model.QuantidadeCaixasSaidaLotePagina(data.QuantidadeCaixasSaidaLotePagina);
                self.model.QuantidadeReservaLotePagina(data.QuantidadeReservaLotePagina);
                self.model.QuantidadeCaixasReservaLotePagina(data.QuantidadeCaixasReservaLotePagina);
            }
        });
    },

    atualizarPaginador: function(data) {

        this.paginador = new Paginator({
            container: "#page-consulta-lotes-reservados",
            data: data,
            pageClickCallback: $.proxy(this.paginar, this)
        });

    },

    paginar: function(e) {
        this.pesquisar(e.page);
    },
})

window.LotesReservadosProdutoConsultaController = LotesReservadosProdutoConsultaController

export {
    LotesReservadosProdutoConsultaController
}